import { UseQueryResult } from '@smuchile/pkg-unimarc-hooks'
import { ResponseOrderFormProps } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/IOrderForm'
import { ISlaSimulationResponse } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/ISlaSimulation'

export const handleSelectAddress = ({
  orderForm,
  localSla
}: {
  orderForm: UseQueryResult<ResponseOrderFormProps>
  localSla: ISlaSimulationResponse
}) => {
  const selectedAddresses = orderForm?.data?.data?.selectedAddresses
  const isPickup = selectedAddresses?.addressType == 'pickup-in-point'
  const addressDelivery = selectedAddresses?.street
    ? `${selectedAddresses?.street} ${selectedAddresses?.number}${
        selectedAddresses?.complement != ''
          ? ', ' + selectedAddresses?.complement
          : ''
      }, ${selectedAddresses?.city} ${selectedAddresses.neighborhood}`
    : ''
  const store = !localSla
    ? ''
    : localSla?.slas?.[0]?.store?.friendlyName ??
      selectedAddresses?.neighborhood

  const addressSelected = isPickup ? `Unimarc ${store}` : addressDelivery

  return {
    addressDelivery,
    addressSelected,
    isPickup,
    selectedAddresses
  }
}
